export class StoreHandler {
	//__________   SET    __________//
	static setState = (state, { values, scope }) => {
		const Val = values ? values : {};
		const Sc = scope ? scope.split('.') : [];

		switch (Sc.length) {
			case 0:
				return { ...state, ...Val };
			case 1:
				return { ...state, [Sc[0]]: { ...state[Sc[0]], ...Val } };
			case 2:
				return {
					...state,
					[Sc[0]]: { ...state[Sc[0]], [Sc[1]]: { ...state[Sc[0]][Sc[1]], ...Val } },
				};
			case 3:
				return {
					...state,
					[Sc[0]]: {
						...state[Sc[0]],
						[Sc[1]]: {
							...state[Sc[0]][Sc[1]],
							[Sc[2]]: { ...state[Sc[0]][Sc[1]][Sc[2]], ...Val },
						},
					},
				};
			case 4:
				return {
					...state,
					[Sc[0]]: {
						...state[Sc[0]],
						[Sc[1]]: {
							...state[Sc[0]][Sc[1]],
							[Sc[2]]: {
								...state[Sc[0]][Sc[1]][Sc[2]],
								[Sc[3]]: {
									...state[Sc[0]][Sc[1]][Sc[2]][Sc[3]],
									...Val,
								},
							},
						},
					},
				};
			case 5:
				return {
					...state,
					[Sc[0]]: {
						...state[Sc[0]],
						[Sc[1]]: {
							...state[Sc[0]][Sc[1]],
							[Sc[2]]: {
								...state[Sc[0]][Sc[1]][Sc[2]],
								[Sc[3]]: {
									...state[Sc[0]][Sc[1]][Sc[2]][Sc[3]],
									[Sc[4]]: {
										...state[Sc[0]][Sc[1]][Sc[2]][Sc[3]][Sc[4]],
										...Val,
									},
								},
							},
						},
					},
				};
			default:
				return { ...state };
		}
	};
	//__________   Clear    __________//
	static clearState = (state, initState, { values, scope }) => {
		const Sc = scope ? scope.split('.') : [];
		const Val = values ? values : {};

		switch (Sc.length) {
			case 0:
				return { ...initState, ...Val };
			case 1:
				return { ...state, [Sc[0]]: { ...initState[Sc[0]], ...Val } };
			case 2:
				return {
					...state,
					[Sc[0]]: { ...state[Sc[0]], [Sc[1]]: { ...initState[Sc[0]][Sc[1]], ...Val } },
				};
			case 3:
				return {
					...state,
					[Sc[0]]: {
						...state[Sc[0]],
						[Sc[1]]: {
							...state[Sc[0]][Sc[1]],
							[Sc[2]]: { ...initState[Sc[0]][Sc[1]][Sc[2]], ...Val },
						},
					},
				};
			case 4:
				return {
					...state,
					[Sc[0]]: {
						...state[Sc[0]],
						[Sc[1]]: {
							...state[Sc[0]][Sc[1]],
							[Sc[2]]: {
								...state[Sc[0]][Sc[1]][Sc[2]],
								[Sc[3]]: {
									...initState[Sc[0]][Sc[1]][Sc[2]][Sc[3]],
									...Val,
								},
							},
						},
					},
				};
			case 5:
				return {
					...state,
					[Sc[0]]: {
						...state[Sc[0]],
						[Sc[1]]: {
							...state[Sc[0]][Sc[1]],
							[Sc[2]]: {
								...state[Sc[0]][Sc[1]][Sc[2]],
								[Sc[3]]: {
									...state[Sc[0]][Sc[1]][Sc[2]][Sc[3]],
									[Sc[4]]: {
										...initState[Sc[0]][Sc[1]][Sc[2]][Sc[3]][Sc[4]],
										...Val,
									},
								},
							},
						},
					},
				};
			default:
				return { ...initState };
		}
	};
}

export default StoreHandler;
